import { defineStore } from 'pinia'
import type { RecommendedHall } from '~/components/product/recommended-hall-type'
import { useRelativeQuantityChangeMutation } from '~/composables/queries/basket'

export const useProductModalStore = defineStore('productModal', () => {
  const { mutate } = useRelativeQuantityChangeMutation()

  const isOpen = ref<boolean>(false)
  const hasWarranty = ref<boolean>(false)
  const recommendedHalls = ref<RecommendedHall[]>([])

  const setIsOpen = (newIsOpen: boolean) => {
    isOpen.value = newIsOpen
  }
  const setHasWarranty = (newHasWarranty: boolean) => {
    hasWarranty.value = newHasWarranty
  }

  const openModalForProduct = (productId: number, amount: number, variationId: number | null, optionIds: number[] | null, onComplete?: () => void) => {
    mutate(
      {
        productId,
        amount,
        variationId,
        optionIds,
      },
      {
        onSuccess(response) {
          recommendedHalls.value = response.recommendedHalls
          isOpen.value = true
          onComplete?.()
        },
      }
    )
  }

  return {
    isOpen,
    hasWarranty,
    recommendedHalls,
    setIsOpen,
    setHasWarranty,
    openModalForProduct,
  }
})
